module.exports = __webpack_public_path__ + "static/img/move.9d3b49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/move.png
// module id = xDoK
// module chunks = 1